<template>
  <nav class="menu">
    <div class="menu__wrap">
      <header class="menu__header header">
        <h1 class="header__title link" v-on:click="trigger"><router-link :to="{ name: 'FrontPage', params: {} }">desperate<span class="header__title__dot">.</span></router-link></h1>
        <div class="header__nav-trigger" v-on:click="trigger">close menu</div>
      </header>
      <div class="container">
        <ul class="menu__list">
          <li class="menu__list__item link" :style="{backgroundImage: `url(${menu1})`}" @click="() => trigger('FrontPage')">
            <div class="menu__list__item__wrap">
              <h1 class="menu__list__item__head">take me home</h1>
              <h2 class="menu__list__item__sub">see who works here and what we've done!</h2>
            </div>
          </li>
          <li class="menu__list__item link" :style="{backgroundImage: `url(${menu3})`}" @click="() => trigger('About')">
            <div class="menu__list__item__wrap">
              <h1 class="menu__list__item__head">read about us</h1>
              <h2 class="menu__list__item__sub">see who works here and what we've done!</h2>
            </div>
          </li>
          <li class="menu__list__item link" :style="{backgroundImage: `url(${menu4})`}" @click="() => trigger('Contact')">
            <div class="menu__list__item__wrap">
              <h1 class="menu__list__item__head">contact us</h1>
              <h2 class="menu__list__item__sub">see who works here and what we've done!</h2>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import './style.scss';

import menu1 from '@/assets/menu1.png';
import menu2 from '@/assets/menu2.png';
import menu3 from '@/assets/menu3.png';
import menu4 from '@/assets/menu4.png';

export default {
  name: 'Menu',
  data() {
    return {
      menu1,
      menu2,
      menu3,
      menu4,
    };
  },
  methods: {
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Menu/Menu.vue